import React, { useState } from "react";
import ProPlayer from "./ProPlayer";
import { RiApps2AddFill } from "react-icons/ri";
import { FaAngleDown } from "react-icons/fa6";
import { BsCameraVideoFill } from "react-icons/bs";
import { HiMiniDocumentText } from "react-icons/hi2";
import { RiAddCircleLine } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { Messager } from "./Messager";
import { deleteSession } from "../../services/coures/deleteSession";


export const Syllabus = ({
    syllabusData = [],
    loadingSyllabus,
    activeSession,
    loadingSession,
    BeURL,
    handleUploadSession,
    handlefetchVideo,
    handlefetchUpdateSession,
    openCreateSyllabusModal
}) => {

    const [openSyllabus, setOpenSyllabus] = useState(null);
    const [activeId, setActiveId] = useState(null);

    const handleDeleteSession = async (sessionId) => {
        if (!sessionId) {
            alert("Session id is missing");
            return;
        }

        const confirmDelete = window.confirm(
            "Are you sure you want to delete this session?"
        );

        if (!confirmDelete) return;

        try {
            const res = await deleteSession({ BeURL, sessionId });

            if (!res?.success) {
                alert(res?.message || "Delete failed");
                return;
            }

            alert("Session deleted successfully");

            // refresh syllabus
            // handleFetchSyllabus(selectedCourse);

        } catch (err) {
            console.error("Delete error:", err);
            alert("Server error during delete");
        }
    };



    return (
        <div className="min-h-screen">
            <div className="grid grid-cols-12 gap-5">
                {/* ================= LEFT PANEL ================= */}
                <aside
                    className="col-span-12 md:col-span-4 xl:col-span-3 bg-white rounded-xl shadow-lg p-4 sticky top-4  h-[calc(100vh-2rem)] flex flex-col "
                >
                    {/* TITLE */}
                    <div className="flex flex-wrap items-center justify-between gap-3 mb-4">

                        {/* Title */}
                        <h3 className="text-lg font-semibold text-gray-800 tracking-wide">
                            Syllabus
                        </h3>

                        {/* Button */}
                        <button
                            onClick={openCreateSyllabusModal}
                            className="
      inline-flex items-center gap-2
      bg-primary-600 hover:to-primary-800
      px-4 py-2
      rounded-xl
      text-white text-sm font-semibold
      shadow-md hover:shadow-lg
      transition-all duration-200
    "
                        >
                            <RiAddCircleLine size={18} />
                            Create Curriculum
                        </button>

                    </div>


                    {/* SCROLL AREA */}
                    <div className="flex-1 overflow-y-auto pr-2 space-y-3 hide-scrollbar">
                        {loadingSyllabus ? (
                            <p className="text-gray-400 text-sm">Loading...</p>
                        ) : syllabusData.length === 0 ? (
                            <p className="text-gray-400 text-sm">No syllabus created</p>
                        ) : (
                            syllabusData.map((item, i) => {
                                const isOpen = openSyllabus === item._id;

                                return (
                                    <div key={item._id} className="rounded-xl">
                                        {/* MODULE CARD */}
                                        <div
                                            className="group rounded-2xl bg-white/80 backdrop-blur-xl  shadow-[0_8px_30px_rgb(0,0,0,0.04)]  hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] transition-all"
                                        >
                                            {/* HEADER */}
                                            <div
                                                onClick={() =>
                                                    setOpenSyllabus(isOpen ? null : item._id)
                                                }
                                                className={`flex items-center justify-between px-5 py-4 cursor-pointer ${isOpen ? "bg-blue-50/40" : ""}`}
                                            >
                                                {/* LEFT */}
                                                <div className="flex items-center gap-4">
                                                    <div
                                                        className="w-9 h-9 flex items-center justify-center rounded-xl bg-secondary-500 text-white text-sm font-semibold shadow-sm"
                                                    >
                                                        {i + 1}
                                                    </div>

                                                    <div>
                                                        <p className="text-[15px] font-semibold text-gray-900">
                                                            {item.syllabus?.title}
                                                        </p>
                                                        <p className="text-xs text-gray-400">
                                                            {item.sessions?.length || 0} lessons
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* RIGHT */}
                                                <div className="flex items-center gap-3">
                                                    <FaAngleDown
                                                        className={`transition-all duration-300 ${isOpen
                                                                ? "rotate-180 text-blue-600"
                                                                : "text-gray-400 group-hover:text-gray-600"} `}
                                                    />

                                                    <button
                                                        type="button"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleUploadSession(item);
                                                        }}
                                                        title="Add lesson"
                                                        className="opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all p-2 rounded-xl bg-gray-100 hover:bg-blue-100 text-gray-600 hover:text-blue-600"
                                                    >
                                                        <RiApps2AddFill size={18} />
                                                    </button>
                                                </div>
                                            </div>

                                            {/* BODY */}
                                            <div
                                                className={`grid transition-all duration-300 ease-out  ${isOpen
                                                        ? "grid-rows-[1fr] opacity-100"
                                                        : "grid-rows-[0fr] opacity-0"}`}
                                            >
                                                <div className="overflow-hidden px-5 pb-4 pt-2 space-y-2">
                                                    {item.sessions?.length ? (
                                                        item.sessions.map((session, si) => {
                                                            const isActive = activeId === session._id;

                                                            return (
                                                                <div
                                                                    key={session._id}
                                                                    onClick={() => {
                                                                        if (!session.unlocked) return;
                                                                        setActiveId(session._id);
                                                                        handlefetchVideo(session._id);
                                                                    }}
                                                                    className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm transition-all ${session.unlocked
                                                                            ? isActive
                                                                                ? "bg-blue-50 ring-1 ring-blue-200 shadow-sm"
                                                                                : "hover:bg-white hover:shadow cursor-pointer"
                                                                            : "opacity-40 cursor-not-allowed"
                                                                        } `}
                                                                >
                                                                    <div
                                                                       className={`w-8 h-8 rounded-lg flex items-center justify-center  ${isActive ? "bg-blue-100" : "bg-gray-100"}  `}
                                                                    >
                                                                        {session.type === "video" ? <BsCameraVideoFill /> : <HiMiniDocumentText />}
                                                                    </div>

                                                                    <span
                                                                        className={`flex-1 ${isActive
                                                                                ? "text-blue-700 font-medium"
                                                                                : "text-gray-800"
                                                                            } `}
                                                                    >
                                                                        {si + 1}. {session.title}
                                                                    </span>
                                                                    {/* Action Buttons */}
                                                                    <div className="flex gap-2 ">
                                                                        <button
                                                                            onClick={() => handlefetchUpdateSession(session?._id)}
                                                                            title="edit session"
                                                                            type="button"
                                                                            className="inline-flex items-center text-sm font-medium opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-10  transition-all text-primary-600 rounded-md "
                                                                        >
                                                                            <FiEdit />
                                                                        </button>

                                                                        <button
                                                                            onClick={() => handleDeleteSession(session?._id)}
                                                                            title="delete session"
                                                                            type="button"
                                                                            className="inline-flex items-center text-sm font-medium opacity-0 group-hover:opacity-100  scale-95 group-hover:scale-100  transition-all text-red-600 rounded-md"
                                                                        >
                                                                            <MdDelete />
                                                                        </button>
                                                                    </div>
                                                      
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <p className="text-xs text-gray-400">No lessons yet</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </aside>






                {/* ================= MAIN VIEW ================= */}
                <main className="col-span-12 md:col-span-8 xl:col-span-9 bg-white rounded-xl shadow-xl p-6">

                    {!activeSession ? (

                        <div className="flex flex-col items-center justify-center h-[400px] text-gray-400">

                            <span className="text-4xl mb-3">📤</span>

                            <p>Select a lesson to preview</p>

                        </div>

                    ) : loadingSession ? (

                        <p className="text-center text-gray-400 mt-20">
                            Loading preview...
                        </p>

                    ) : (

                        <>
                            {/* Lesson Header */}
                                    <div className="flex flex-col gap-3 mb-4 border-b pb-4 sm:flex-row sm:items-center sm:justify-between">
                                        {/* Title Section */}
                                        <div>
                                            <h2 className="text-xl font-semibold text-gray-800">
                                                {activeSession?.title}
                                            </h2>
                                            <p className="text-sm text-gray-500 capitalize">
                                                {activeSession?.description} content
                                            </p>
                                        </div>
                                    </div>
                            {/* Preview */}
                            <div className="bg-gray-50 rounded-xl p-4 shadow-inner">

                                {activeSession.type === "video" && (

                                    <ProPlayer
                                        session={activeSession}
                                        BeURL={BeURL}
                                    />

                                )}
                                {activeSession.type === "pdf" && (

                                    <iframe
                                        src={`${BeURL}${activeSession.file?.storage?.path}`}
                                        className="w-full h-[550px] rounded-xl"
                                        title="PDF Preview"
                                    />
                                )}

                                {activeSession.type === "image" && (
                                    <img
                                        src={`${BeURL}${activeSession.file?.storage?.path}`}
                                        alt={activeSession.title}
                                        className="w-full max-h-[500px] object-contain rounded-xl"
                                    />

                                )}
                                {activeSession.type === "description" && (
                                    <div className="bg-white p-4 rounded-xl text-gray-700 text-sm leading-relaxed">

                                        {activeSession.description}

                                    </div>
                                )}
                            </div>
                        </>
                    )}

                </main>

            </div>

            <Messager />

        </div>
    );
};
